import React, { useEffect, useState, useContext, useRef } from "react";
import { getRawMaterials, getUnits, get_rawtransaction } from "../../../../Utility/Api";
import { useNavigate } from "react-router-dom";
import { NaviGate, shop_id } from "../../../../Utility/function";
import { WarehouseContext } from "../../../../Utility/UserContext";
import "./../table.css";
import * as XLSX from "xlsx";

const RawMaterialReport = () => {
    const navigate = useNavigate();
    const { showLoader, hideLoader, shopItem } = useContext(WarehouseContext);
    const [rawMaterials, setRawMaterials] = useState([]);
    const [unitsList, setUnitsList] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [selectedType, setSelectedType] = useState("");
    const [stockStatus, setStockStatus] = useState("");
    const [companyInfo, setCompanyInfo] = useState({
        name: "ZTR Masala",
        address: "Business Address",
        phone: "",
        email: ""
    });

    useEffect(() => {
        if (shopItem) {
            setCompanyInfo({
                name: shopItem?.title || "ZTR Masala",
                address: shopItem?.Address || "Business Address",
                phone: shopItem?.phone1 || "",
                email: shopItem?.email || ""
            });
        }
    }, [shopItem]);

    useEffect(() => {
        fetchData();
        fetchUnits();
    }, []);

    const fetchData = async () => {
        try {
            showLoader();
            const response = await getRawMaterials();
            const txnResponse = await get_rawtransaction("", 100000, "", "1");
            
            const totalsMap = {};
            if (txnResponse.data && txnResponse.data.data) {
                txnResponse.data.data.forEach(t => {
                    const rawId = String(t.raw_mat_id);
                    if (!totalsMap[rawId]) {
                        totalsMap[rawId] = {
                            total_qty: 0,
                            total_price: 0
                        };
                    }
                    totalsMap[rawId].total_qty += parseFloat(t.qty || 0);
                    totalsMap[rawId].total_price += parseFloat(t.price || 0);
                });
            }

            if (response.data && response.data.data) {
                const enriched = response.data.data.map(item => {
                    const totals = totalsMap[String(item.id)] || { total_qty: 0, total_price: 0 };
                    return {
                        ...item,
                        total_qty: totals.total_qty,
                        total_price: totals.total_price
                    };
                });
                setRawMaterials(enriched);
            }
            hideLoader();
        } catch (error) {
            hideLoader();
            console.error("Error fetching raw materials data:", error);
        }
    };

    const fetchUnits = async () => {
        try {
            const response = await getUnits();
            if (response.data && response.data.data) {
                setUnitsList(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching units:", error);
        }
    };

    const getUnitName = (unitId) => {
        if (!unitId) return "";
        const found = unitsList.find(u => String(u.id) === String(unitId));
        if (found) return found.title;
        if (String(unitId) === "1") return "kg";
        if (String(unitId) === "2") return "gram";
        return unitId;
    };

    const applyFilters = () => {
        let filtered = [...rawMaterials];

        // Type filter: Spices (2) or Packaging Material (1)
        if (selectedType) {
            filtered = filtered.filter(item => String(item.type) === String(selectedType));
        }

        // Stock status filter
        if (stockStatus === "low") {
            filtered = filtered.filter(item => {
                const stock = parseFloat(item.remaining_stock || 0);
                const reorder = parseFloat(item.reorder_point || 0);
                return stock <= reorder;
            });
        } else if (stockStatus === "instock") {
            filtered = filtered.filter(item => {
                const stock = parseFloat(item.remaining_stock || 0);
                const reorder = parseFloat(item.reorder_point || 0);
                return stock > reorder;
            });
        }

        // Search text
        if (searchText) {
            const search = searchText.toLowerCase();
            filtered = filtered.filter(item =>
                (item.title && item.title.toLowerCase().includes(search)) ||
                (item.product_code && item.product_code.toLowerCase().includes(search))
            );
        }

        return filtered;
    };

    const filteredData = applyFilters();

    const handlePrint = () => {
        const printWindow = window.open('', '_blank');
        const printContent = document.getElementById('printable-raw-material-report').innerHTML;

        printWindow.document.write(`
            <!DOCTYPE html>
            <html>
            <head>
                <title>Raw Material Report</title>
                <style>
                    @media print {
                        @page {
                            size: A4 portrait;
                            margin: 0.5in;
                        }
                        body {
                            font-family: Arial, sans-serif;
                            font-size: 12pt;
                            color: #000;
                            background: #fff;
                        }
                        .print-container {
                            width: 100%;
                            max-width: 21cm;
                            margin: 0 auto;
                        }
                        .print-header {
                            text-align: center;
                            margin-bottom: 20px;
                            border-bottom: 2px solid #000;
                            padding-bottom: 15px;
                        }
                        .print-header h1 {
                            font-size: 20pt;
                            margin: 0;
                            color: #000;
                        }
                        .print-header p {
                            margin: 5px 0;
                            font-size: 11pt;
                        }
                        .report-info {
                            margin: 15px 0;
                            padding: 10px;
                            background-color: #f8f9fa;
                            border-radius: 5px;
                            display: flex;
                            justify-content: space-between;
                        }
                        .report-table {
                            width: 100%;
                            border-collapse: collapse;
                            margin: 15px 0;
                            font-size: 10pt;
                        }
                        .report-table th, .report-table td {
                            border: 1px solid #ddd;
                            padding: 8px;
                            text-align: left;
                        }
                        .report-table th {
                            background-color: #f2f2f2;
                            font-weight: bold;
                        }
                        .low-stock {
                            background-color: #ffe6e6 !important;
                            color: #cc0000;
                            font-weight: bold;
                        }
                        .report-totals {
                            margin-top: 20px;
                            padding: 15px;
                            border: 1px solid #ddd;
                            border-radius: 5px;
                            background-color: #f9f9f9;
                        }
                        .total-row {
                            display: flex;
                            justify-content: space-between;
                            margin: 5px 0;
                        }
                        .total-amount {
                            font-weight: bold;
                            font-size: 13pt;
                        }
                        .footer {
                            margin-top: 30px;
                            text-align: center;
                            font-size: 10pt;
                            color: #6c757d;
                        }
                    }
                </style>
            </head>
            <body>
                ${printContent}
                <script>
                    window.onload = function() {
                        window.print();
                        setTimeout(function() {
                            window.close();
                        }, 100);
                    };
                </script>
            </body>
            </html>
        `);
        printWindow.document.close();
    };

    const exportToExcel = () => {
        const exportData = filteredData.map((item, index) => ({
            "S.No": index + 1,
            "Title": item.title,
            "Type": String(item.type) === "1" ? "Packaging material" : "Spices",
            "Product Code": item.product_code || "N/A",
            "Reorder Point": item.reorder_point || 0,
            "Latest Price (INR)": item.latest_price_unit || 0.0,
            "Stocks Available": `${parseFloat(item.remaining_stock || 0).toFixed(2)} ${getUnitName(item.unit_id)}`
        }));

        const ws = XLSX.utils.json_to_sheet(exportData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Raw_Material_Report");
        XLSX.writeFile(wb, `Raw_Material_Report_${new Date().toISOString().split('T')[0]}.xlsx`);
    };

    const totalMaterials = filteredData.length;
    const lowStockCount = filteredData.filter(item => parseFloat(item.remaining_stock || 0) <= parseFloat(item.reorder_point || 0)).length;

    return (
        <div className="page-content py-1">
            <NaviGate />
            <div className="card p-3 mx-2 overflow-y-scroll" style={{ minHeight: "90vh" }}>
                <div className="d-flex mb-4 border-bottom justify-content-between align-items-center flex-wrap pb-3" style={{ width: "100%" }}>
                    <h5 className="text-start w-auto fw-bold mb-0 text-uppercase">
                        Raw Material Report
                    </h5>
                    <div className="d-flex gap-2 align-items-center flex-wrap ms-auto">
                        
                        {/* Search Bar */}
                        <div style={{ width: "220px" }}>
                            <div className="form-floating">
                                <input
                                    className="form-control"
                                    value={searchText}
                                    onChange={(e) => setSearchText(e.target.value)}
                                    placeholder="Search"
                                />
                                <label>Search Material/Code</label>
                            </div>
                        </div>

                        {/* Filter by Type */}
                        <div style={{ width: "160px" }}>
                            <div className="form-floating">
                                <select
                                    className="form-select"
                                    value={selectedType}
                                    onChange={(e) => setSelectedType(e.target.value)}
                                >
                                    <option value="">All Types</option>
                                    <option value="2">Spices</option>
                                    <option value="1">Packaging material</option>
                                </select>
                                <label>Material Type</label>
                            </div>
                        </div>

                        {/* Filter by Stock Status */}
                        <div style={{ width: "160px" }}>
                            <div className="form-floating">
                                <select
                                    className="form-select"
                                    value={stockStatus}
                                    onChange={(e) => setStockStatus(e.target.value)}
                                >
                                    <option value="">All Stock Status</option>
                                    <option value="low">Low Stock Alert</option>
                                    <option value="instock">In Stock</option>
                                </select>
                                <label>Stock Status</label>
                            </div>
                        </div>

                        {/* Print Button */}
                        <button
                            type="button"
                            className="btn btn-dark p-3"
                            onClick={handlePrint}
                            style={{ height: "58px" }}
                        >
                            <i className="bi bi-printer me-1"></i> Print
                        </button>
                    </div>
                </div>

                <div className="d-flex justify-content-between mb-3 px-2">
                    <div>
                        <strong>Total Items:</strong> {totalMaterials}
                    </div>
                    <div>
                        <strong>Low Stock Alerts:</strong> <span className={lowStockCount > 0 ? "text-danger fw-bold" : "text-success"}>{lowStockCount}</span>
                    </div>
                </div>

                {/* Table View */}
                <div className="table-responsive text-center my-2 w-100 position-relative">
                    <table className="table table-sm table-bordered table-hover">
                        <thead className="table-dark">
                            <tr>
                                <th>S.No</th>
                                <th>Title</th>
                                <th>Type</th>
                                <th>Product Code</th>
                                <th>Reorder Point</th>
                                <th>Latest Price (INR)</th>
                                <th>Total Quantity</th>
                                <th>Total Price (INR)</th>
                                <th>Stocks Available</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredData.length > 0 ? (
                                filteredData.map((item, index) => {
                                    const stock = parseFloat(item.remaining_stock || 0);
                                    const totalQty = parseFloat(item.total_qty || 0);
                                    const totalPrice = parseFloat(item.total_price || 0);
                                    const reorder = parseFloat(item.reorder_point || 0);
                                    const isLowStock = stock <= reorder;

                                    return (
                                        <tr key={item.id} className={isLowStock ? "table-warning" : ""}>
                                            <td>{index + 1}</td>
                                            <td className="fw-semibold">{item.title}</td>
                                            <td>{String(item.type) === "1" ? "Packaging material" : "Spices"}</td>
                                            <td>{item.product_code || "N/A"}</td>
                                            <td>{item.reorder_point || 0}</td>
                                            <td>{parseFloat(item.latest_price_unit || 0).toFixed(2)}</td>
                                            <td>{totalQty.toFixed(2)} {getUnitName(item.unit_id)}</td>
                                            <td>{totalPrice.toFixed(2)}</td>
                                            <td>
                                                <span className={isLowStock ? "text-danger fw-bold" : ""}>
                                                    {stock.toFixed(2)} {getUnitName(item.unit_id)}
                                                    {isLowStock && (
                                                        <span className="ms-1 badge bg-danger text-white">Low Stock</span>
                                                    )}
                                                </span>
                                            </td>
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td colSpan="9" className="text-center py-4 text-muted">
                                        No raw materials found.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {/* Printable Report (Hidden in normal screen view) */}
                <div id="printable-raw-material-report" style={{ display: 'none' }}>
                    <div className="print-container">
                        <div className="print-header">
                            <h1>{companyInfo.name}</h1>
                            <p>{companyInfo.address}</p>
                            <p>Phone: {companyInfo.phone} | Email: {companyInfo.email}</p>
                            <h2 style={{ marginTop: '20px', textTransform: 'uppercase' }}>Raw Material Stock Report</h2>
                        </div>

                        <div className="report-info">
                            <div>
                                <strong>Generated On:</strong> {new Date().toLocaleDateString()} at {new Date().toLocaleTimeString()}
                            </div>
                            <div>
                                <strong>Total Items:</strong> {totalMaterials} | <strong>Low Stock Items:</strong> {lowStockCount}
                            </div>
                        </div>

                        <table className="report-table">
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Title</th>
                                    <th>Type</th>
                                    <th>Product Code</th>
                                    <th>Reorder Point</th>
                                    <th>Latest Price (INR)</th>
                                    <th>Total Quantity</th>
                                    <th>Total Price (INR)</th>
                                    <th>Stocks Available</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredData.length > 0 ? (
                                    filteredData.map((item, index) => {
                                        const stock = parseFloat(item.remaining_stock || 0);
                                        const totalQty = parseFloat(item.total_qty || 0);
                                        const totalPrice = parseFloat(item.total_price || 0);
                                        const reorder = parseFloat(item.reorder_point || 0);
                                        const isLowStock = stock <= reorder;

                                        return (
                                            <tr key={item.id}>
                                                <td>{index + 1}</td>
                                                <td style={{ fontWeight: 'bold' }}>{item.title}</td>
                                                <td>{String(item.type) === "1" ? "Packaging material" : "Spices"}</td>
                                                <td>{item.product_code || "N/A"}</td>
                                                <td>{item.reorder_point || 0}</td>
                                                <td>{parseFloat(item.latest_price_unit || 0).toFixed(2)}</td>
                                                <td>{totalQty.toFixed(2)} {getUnitName(item.unit_id)}</td>
                                                <td>{totalPrice.toFixed(2)}</td>
                                                <td className={isLowStock ? "low-stock" : ""}>
                                                    {stock.toFixed(2)} {getUnitName(item.unit_id)}
                                                    {isLowStock && " (LOW)"}
                                                </td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan="9" style={{ textAlign: 'center' }}>
                                            No raw materials found.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>

                        <div className="report-totals">
                            <h3>Report Summary</h3>
                            <div className="total-row">
                                <span>Total Raw Materials Listed:</span>
                                <span className="total-amount">{totalMaterials}</span>
                            </div>
                            <div className="total-row">
                                <span>Low Stock Alerts:</span>
                                <span className="total-amount" style={{ color: lowStockCount > 0 ? '#cc0000' : '#28a745' }}>
                                    {lowStockCount}
                                </span>
                            </div>
                        </div>

                        <div className="footer">
                            <p>ZTR Masala Inventory Management System</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RawMaterialReport;
